import {FileSizeType, FileSizeMetric} from './constants';
import {fileSizeRuleDefaults} from './defaults';
import {FileSizeRule} from './types';

type GetFileSizeRuleParams<
	T extends FileSizeType = typeof fileSizeRuleDefaults.elementSubType1,
	T2 extends FileSizeMetric = typeof fileSizeRuleDefaults.elementSubType2,
> = {
	fileSize: number;
	metric?: T2;
	type?: T;
};

export const createFileSizeRule = ({
	fileSize,
	metric,
	type,
}: GetFileSizeRuleParams): FileSizeRule => ({
	...fileSizeRuleDefaults,
	elementSubType1: type != null ? type : fileSizeRuleDefaults.elementSubType1,
	elementSubType2:
		metric != null ? metric : fileSizeRuleDefaults.elementSubType2,
	elementValue1: fileSize,
});

export default createFileSizeRule;
